import $ from 'jquery';

export default () => {
  $('.paragraph--type--contact-form form.contact-form .form-actions input[type=submit]').on('mousedown', function(event) {
    const $form = $(this).parents('form');

    dataLayer.push({
      'event': 'gtm.formSubmit',
      'gtm.element': $form[0],
      'gtm.elementClasses': $form.attr('class'),
      'gtm.elementId': $form.attr('id')
    });
  });

  let $regions;

  Drupal.behaviors.exposed_form_submission = {
    attach: function(context, settings) {
      $regions = $regions || $('.region-hero, .region-content');
      const selector = '[id^=views-exposed-form]';
      const $forms = $(selector, context).addBack(selector);
      const $bef = $regions.find($forms).once('bef-gtm');
      const filters = [];

      $bef.find('input[type=submit]').on('click mousedown', function() {
        const $form = $(this).parents('form');
        const $items = $form.find('.form-item');

        $items.each(function() {
          const $item = $(this);

          switch(getItemType($item)) {
            case 'select':
              const index = $item.find('select').val();
              const value = $item.find('option')
                .filter(`[value=${index}]`)
                .text();
              filters.push(value);
              break;
            default:
              filters.push($item.find('input').val());
              break;
          }
        });

        $form.addClass('views-exposed-form');

        dataLayer.push({
          'event': 'exposedForm',
          'formFilters': normalizeFilters(filters)
        });
      });
    }
  };

  function getItemType($item) {
    return $item.attr('class')
      .split(/\s+/)
      .filter(className => className.startsWith('form-type'))
      .pop()
      .split('-')
      .pop();
  }

  function normalizeFilters(filters) {
    return filters
      .map(filter => filter.replace(/-/g, ''))
      .map(filter => filter.trim())
      .filter(filter => filter.length)
      .join(' - ');
  }
}
